import axios from 'axios';
import requestField from "@/store/modules/requestField";


export default {
  url: function(){
    return process.env.VUE_APP_API_URL;
  },
  checkExecutionErrorVue: function (vueSelf, response, frontMethod) {
    if (response['Response']['ExecutionError']['ExecutionErrorCode'] === 0) {
      return true;
    }

    let err = '';
    if (response['Response']['ExecutionError']['ExecutionErrorMessage'] != undefined) {
      err = response['Response']['ExecutionError']['ExecutionErrorMessage'];
    } else {
      err = JSON.stringify(response);
    }

    vueSelf.$store.commit('showModal');
    vueSelf.$store.commit('setContent',err);
    return false;
  },
  checkErrorCodeVue: function (response, vueSelf, frontMethod) {
    let errorMsg = 'Ошибка, <hr/>JS - ' + frontMethod + '<hr/>' + JSON.stringify(response);
    if (response === null) {
      vueSelf.$store.commit('showModal');
      vueSelf.$store.commit('setContent', errorMsg);
      vueSelf.$store.commit('userCanCloseModal');
      return {result: false, reload: false};
    }
    if (response.Error['ErrorCode'] < 0) {
      vueSelf.$store.commit('showModal');
      vueSelf.$store.commit('setContent', errorMsg);
      vueSelf.$store.commit('userCanCloseModal');
      return {result: false, reload: false};
    }
    if (response.Error['ErrorCode'] > 0) {
      return {result: true, reload: true};
    }
    if (response.Error['ErrorCode'] === 0) {
      vueSelf.$store.commit('userCanCloseModal');
      let responeResult = true;
      if (response.hasOwnProperty('Response')) {
        responeResult = this.checkExecutionErrorVue(vueSelf, response, frontMethod);
      }
      if (responeResult) {
        return {result: true, reload: false};
      } else {
        return {result: false, reload: false};
      }
    }
    vueSelf.$store.commit('setContent', errorMsg);
    return {result: false, reload: false}
  },
  SendRequest: function (sendData, vueSelf, debugMarker, showModal,serviceName = '') {
    return new Promise((resolve,reject) => {
      let self = this;
      if (showModal) {
        vueSelf.$store.commit('showModal');
        vueSelf.$store.commit('userCanNotCloseModal');
        vueSelf.$store.commit('setContent', 'Отправкa запроса');
      }

      sendData['token'] = localStorage['user-token'];

      if (serviceName  != '') {
        sendData['sys_name'] = serviceName;
      }

      axios({
        method: 'post',
        url: this.url(),
        data: sendData,
        responseType: 'json',
        headers: {'Content-type': 'application/json'}
      }).then(function (response) {
        // debugger;
        let checkResult = self.checkErrorCodeVue(response.data, vueSelf, 'getGuid/' + debugMarker);
        if (checkResult.result) {
          if (checkResult.reload) {
            vueSelf.$store.commit('setContent', 'Отправкa повторного запроса');
            const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
            wait(2500).then(()=>{
              // console.log(showModal)
              self.SendRequest(sendData, vueSelf, debugMarker, showModal, serviceName)
                .then((res)=>{resolve(res)})
                .catch(()=>{reject(res)});
            });
          } else {
            if (response.data.requestSaveResult != undefined) {
            // if (vueSelf.$store.getters.isVideoScoringActive && response.data.requestSaveResult != undefined) {
              vueSelf.$store.dispatch('saveRequestGuid', response.data.requestSaveResult);
            }

            try {
              serviceName = (response.data.sys_name != undefined) ?  response.data.sys_name : 'portal_iks';
            }
            catch (e) {
              serviceName = 'call_center_iks';
            }
            self.GetRequestResult(response.data['RequestID'],  vueSelf,debugMarker, showModal, serviceName)
              .then((res)=>{resolve(res)})
              .catch((res)=>{reject(res)});
          }
        } else {
            reject(response.data);
        }
      });
    });
  },
  GetRequestResult: function (ExecuteGUID, vueSelf,debugMarker, showModal, serviceName = '') {
    return new Promise((resolve,reject) => {
      let self = this;
      if (showModal) {
        vueSelf.$store.commit('userCanNotCloseModal');
      }
      let sendData = {
        action: 'iks_GetQuery',
        ExecuteGUID: ExecuteGUID,
        token: localStorage['user-token']
      };
      if (serviceName  != '') {
        sendData['sys_name'] = serviceName;
      }
      vueSelf.$store.commit('setContent', 'Идет обработка данных');
      axios({
        method: 'post',
        url: this.url(),
        data: sendData,
        responseType: 'json',
        headers: {'Content-type': 'application/json'}
      }).then(function (response) {
        let checkResult = self.checkErrorCodeVue(response.data, vueSelf, 'getResultSaveForm');
        if (checkResult.result){
          if (checkResult.reload) {
            vueSelf.$store.commit('setContent', 'Отправкa повторного запроса');
            const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
            wait(2500).then(()=>{
              // console.log(showModal)
              self.GetRequestResult(ExecuteGUID, vueSelf,debugMarker, showModal, serviceName)
                .then((res)=>{resolve(res);})
                .catch((res)=>{reject(res)});
            });
          } else {
            resolve(response.data['Response']['ExecutionResult']);
          }
        } else {
          reject(response.data);
        }
      });
    });
  },
  suggestResultGigData: function (query, count){
    return new Promise((resolve, reject) => {
      axios({
        method:'post',
        url: process.env.VUE_APP_API_URL_GIG_DATA,
        headers: {
          'Content-Type': 'application/json',
          'authorization': process.env.VUE_APP_API_URL_GIG_DATA_TOKEN,
        },
        data:{
          query,
          count,
        }
      }).then((resp)=>{
        try {
          resolve(resp);
        } catch (e) {
          reject();
        }
      }).catch(()=>{
        reject();
      });
    });
  },
  suggestResult: function (queryValue){
    return new Promise((resolve, reject) => {
      axios({
        method:'post',
        url:this.url(),
        data:{
          action:'Dadata_getSuggest',
          query:queryValue,
          token:localStorage['user-token']
        }
      }).then((resp)=>{
        try {
          resolve(resp.data.Response.ExecutionResult.suggestions);
        } catch (e) {
          reject();
        }
      }).catch(()=>{
        reject();
      });
    });
  },
  suggestResultPassport: function (queryValue){
    return new Promise((resolve, reject) => {
      axios({
        method:'post',
        url:this.url(),
        data:{
          action:'Dadata_getSuggestPassport',
          query:queryValue,
          token:localStorage['user-token']
        }
      }).then((resp)=>{
        try {
          resolve(resp.data.Response.ExecutionResult.suggestions);
        } catch (e) {
          reject();
        }
      }).catch(()=>{
        reject();
      });
    });
  },
  callSharpApi(sendedData) {
    return new Promise((resolve, reject) => {
      let testDomType = process.env.VUE_APP_API_URL_RUN + sendedData.msUrl;
      console.log(sendedData);
      axios({
        method: 'POST',
        url: testDomType,
        data: sendedData,
      }).then((result) => {
        try {
          if (result.data.Error.Code === 0) {
            resolve(result.data.Data);
          } else {
            reject(result.data.Error);
          }
        } catch (error) {
          reject({
            Code: 1,
            Message: `${sendedData.msUrl} Error message: ${ error }`,
          })
        }
      }).catch((error) => {
        reject({
          Code: 1,
          Message: `${ sendedData.msUrl } Error message: ${ error }`,
        })
      });
    });
  },
  scriptContent: function (){
    return new Promise((resolve, reject) => {
      axios({
        method:'post',
        url:this.url(),
        data:{
          action:'OperatorScript_getContent',
          token:localStorage['user-token']
        }
      }).then((resp)=>{
        try {
          resolve(resp.data.Response.ExecutionResult);
        } catch (e) {
          reject(e);
        }
      }).catch((e)=>{
        reject(e);
      });
    });
  },
  getDefaultDealType: function (){
    return new Promise((resolve, reject) => {
      axios({
        method:'post',
        url:this.url(),
        data:{
          action:'Operator_Get_Default_DealType',
          token:localStorage['user-token']
        }
      }).then((resp)=>{
        try {
          resolve(resp.data.Response.ExecutionResult);
        } catch (e) {
          reject(e);
        }
      }).catch((e)=>{
        reject(e);
      });
    });
  },
  saveDefaultDealType: function (dealTable){
    return new Promise((resolve, reject) => {
      axios({
        method:'post',
        url:this.url(),
        data:{
          action:'Operator_Get_save_DealType',
          token:localStorage['user-token'],
          dealTable:dealTable
        }
      }).then((resp)=>{
        try {
          resolve(resp.data.Response.ExecutionResult);
        } catch (e) {
          reject(e);
        }
      }).catch((e)=>{
        reject(e);
      });
    });
  },
  getWTFlib:function(){
    return new Promise((resolve, reject) => {
      axios({
        method:'post',
        url:this.url(),
        data:{
          action:'Operator_getWTFlib',
          token:localStorage['user-token']
        }
      }).then((resp)=>{
        try {
          if (resp.data['Response']['ExecutionResult'].length > 0) {
            resolve(resp.data['Response']['ExecutionResult']);
          } else {
            reject('Что то пошло не так');
          }
        } catch (e) {
          reject(e);
        }
      }).catch((e)=>{
        reject(e);
      });
    });
  },
  RedirectOperatorToCS:function(){
    return new Promise((resolve, reject) => {
      axios({
        method:'post',
        url:this.url(),
        data:{
          action:'asterisk_redirectToCS',
          token:localStorage['user-token']
        }
      }).then((resp)=>{
        try {
          resolve(resp.data.Response.ExecutionResult);
        } catch (e) {
          reject(e);
        }
      }).catch((e)=>{
        reject(e);
      });
    });
  },
  startCalling: function(phoneClient){
    return new Promise((resolve, reject) => {
      axios({
        method:'post',
        url:this.url(),
        data:{
          action:'asterisk_startCall',
          token:localStorage['user-token'],
          phone:phoneClient
        }
      }).then((resp)=>{
        try {
          resolve(resp.data.Response.ExecutionResult);
        } catch (e) {
          reject(e);
        }
      }).catch((e)=>{
        reject(e);
      });
    });
  },
  singleRequest: function(sendData) {
    sendData.token = localStorage['user-token'];
    return new Promise((resolve, reject) => {
      axios({
        method:'post',
        url:this.url(),
        data:sendData
      }).then((resp)=>{
        try {
          if (resp.data.Response.ExecutionResult !== undefined) {
            resolve(resp.data.Response.ExecutionResult);
          } else {
            reject(resp.data);
          }
        } catch (resp) {
          reject(resp.data);
        }
      }).catch((resp)=>{
        reject(resp.data);
      });
    });
  }
}
